import { v5 as uuidv5 } from 'uuid'

/** Same namespace as Python `uuid.NAMESPACE_URL` / Dagster cantilever ids. */
const UUID_NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'

/**
 * Deterministic UUID5 for a site-scoped cantilever-document file host.
 * Mirrors `document_data_ingestion.defs.cantilever_document.ids.cantilever_document_entry_id`.
 */
export function cantileverDocumentEntryId(
  siteId: string,
  documentId: string
): string {
  return uuidv5(
    `cantilever-document:${siteId}:${documentId}`,
    UUID_NAMESPACE_URL
  )
}

/**
 * Deterministic UUID5 for a site-scoped cantilever-document-page file host.
 * Mirrors `cantilever_document_page_entry_id`.
 */
export function cantileverDocumentPageEntryId(
  siteId: string,
  pageId: string
): string {
  return uuidv5(
    `cantilever-document-page:${siteId}:${pageId}`,
    UUID_NAMESPACE_URL
  )
}

/** Bare BQ page id shape used as UUID5 input: `{document_id}_pg_{n}`. */
export function bareDocumentPageId(
  documentId: string,
  pageNumber: number
): string {
  return `${documentId}_pg_${pageNumber}`
}

/**
 * Derive the cantilever-document-page host id for a page without a Rolodex lookup.
 */
export function cantileverDocumentPageIdForPage(
  siteId: string,
  documentId: string,
  pageNumber: number
): string {
  return cantileverDocumentPageEntryId(
    siteId,
    bareDocumentPageId(documentId, pageNumber)
  )
}
